export const SUPPORTED_LANGS = ['ru', 'be', 'en'];

export const dictionaries = {
  ru: {
    'dashboard.timezone': 'Время: Беларусь, Europe/Minsk / UTC+03',
    'chart.metric': 'Показатель',
    'chart.count': 'Количество транзакций',
    'chart.amount': 'Объём транзакций, NTP',
    'chart.period': 'Суточные итоги по UTC',
    'chart.countTitle': 'Количество транзакций по дням',
    'chart.amountTitle': 'Объём транзакций по дням, NTP',
    'branding.productVersion': 'Версия продукта:',
    'branding.basedOn': 'на базе',
    'common.theme': 'Тема',
    'common.language': 'Язык',
    'common.loading': 'Загрузка',
    'common.error': 'Не удалось загрузить данные',
    'common.empty': 'Данных пока нет',
    'common.apply': 'Применить',
    'common.reset': 'Сбросить',
    'common.open': 'Открыть',
    'common.prev': 'Назад',
    'common.next': 'Вперёд',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'pagination.total': 'всего',
    'pagination.exact': 'точно',
    'pagination.approximate': 'примерно',
    'pagination.page': 'Страница',
    'pagination.perPage': 'На странице',
    'pagination.go': 'Перейти',
    'network.relay': 'Релей',
    'network.storage': 'Хранилище',
    'network.checking': 'проверка',
    'network.online': 'онлайн',
    'network.offline': 'недоступен',
    'network.unconfigured': 'не настроен',
    'search.placeholder': 'Хеш, кошелёк, DSR или ZK',
    'search.label': 'Поиск',
    'search.submit': 'Искать',
    'nav.dashboard': 'Дашборд',
    'nav.transactions': 'Транзакции',
    'nav.wallets': 'Кошельки',
    'dashboard.title': 'Публичная статистика NTP',
    'stats.supply': 'Выпущено',
    'stats.minted': 'Отчеканено',
    'stats.wallets': 'Кошельки',
    'stats.transactions': 'Транзакции',
    'stats.dsr': 'DSR',
    'stats.zk': 'ZK',
    'chart.title': 'Транзакции за 30 дней',
    'transactions.title': 'Транзакции',
    'wallets.title': 'Кошельки',
    'wallet.title': 'Кошелёк',
    'tx.title': 'Транзакция',
    'dsr.title': 'Правила делегированных трат (DSR)',
    'zk.title': 'ZK-купоны',
    'filters.title': 'Фильтры',
    'table.hash': 'Хеш',
    'table.sender': 'Отправитель',
    'table.receiver': 'Получатель',
    'table.amount': 'Сумма',
    'table.date': 'Дата',
    'table.memo': 'Примечание',
    'table.wallet': 'Кошелёк',
    'table.balance': 'Баланс',
    'table.sent': 'Исходящие',
    'table.received': 'Входящие',
    'table.status': 'Статус',
    'table.usage': 'Использование',
    'table.block': 'Блок',
    'table.zk': 'ZK',
    'table.signature': 'Подпись',
    'table.latest': 'Последнее',
    'table.delegate': 'Делегат',
    'table.scope': 'Область',
    'table.wallets': 'Кошельки',
    'table.read': 'Чтение',
    'table.write': 'Запись',
    'table.transfer': 'Переводы',
    'table.txPerHour': 'Транзакций в час',
    'table.amountPerHour': 'Сумма в час',
    'table.singleTx': 'Разовая транзакция',
    'table.dailyLimit': 'Дневной лимит',
    'table.type': 'Тип',
    'table.count': 'Количество',
    'table.billingNonce': 'Биллинговый nonce',
    'table.algorithm': 'Алгоритм',
    'table.profile': 'Профиль',
    'table.lastBilling': 'Последний биллинг',
    'table.paymentVerified': 'Платёж проверен',
    'table.today': 'Сегодня',
    'table.next': 'Следующий',
    'table.deadline': 'Дедлайн',
    'table.created': 'Создан',
    'table.updated': 'Обновлён',
    'table.expires': 'Истекает',
    'filters.wallet': 'Кошелёк',
    'filters.sender': 'Отправитель',
    'filters.receiver': 'Получатель',
    'filters.memo': 'Примечание',
    'filters.from': 'От',
    'filters.to': 'До',
    'filters.min': 'Мин.',
    'filters.max': 'Макс.',
    'filters.status': 'Статус',
    'filters.sort': 'Сортировка',
    'filters.any': 'Любой',
    'filters.publicKey': 'Публичный ключ',
    'detail.keys': 'Публичные ключи',
    'detail.stats': 'Агрегаты',
    'detail.transactions': 'Транзакции',
    'detail.payments': 'Платежи',
    'detail.blocks': 'Блоки',
    'detail.activeBlocks': 'Активные блоки',
    'detail.permissions': 'Разрешения',
    'detail.limits': 'Лимиты',
    'detail.publicData': 'Публичные данные',
    'detail.operations': 'Операции',
    'detail.recentUsage': 'Последние использования',
  },
  be: {
    'dashboard.timezone': 'Час: Беларусь, Europe/Minsk / UTC+03',
    'chart.metric': 'Паказчык',
    'chart.count': 'Колькасць транзакцый',
    'chart.amount': 'Аб’ём транзакцый, NTP',
    'chart.period': 'Сутачныя вынікі паводле UTC',
    'chart.countTitle': 'Колькасць транзакцый па днях',
    'chart.amountTitle': 'Аб’ём транзакцый па днях, NTP',
    'branding.productVersion': 'Версія прадукту:',
    'branding.basedOn': 'на базе',
    'common.theme': 'Тэма',
    'common.language': 'Мова',
    'common.loading': 'Загрузка',
    'common.error': 'Не ўдалося загрузіць даныя',
    'common.empty': 'Даных пакуль няма',
    'common.apply': 'Ужыць',
    'common.reset': 'Скінуць',
    'common.open': 'Адкрыць',
    'common.prev': 'Назад',
    'common.next': 'Наперад',
    'common.yes': 'Так',
    'common.no': 'Не',
    'pagination.total': 'усяго',
    'pagination.exact': 'дакладна',
    'pagination.approximate': 'прыкладна',
    'pagination.page': 'Старонка',
    'pagination.perPage': 'На старонцы',
    'pagination.go': 'Перайсці',
    'network.relay': 'Relay',
    'network.storage': 'Storage',
    'network.checking': 'праверка',
    'network.online': 'анлайн',
    'network.offline': 'недаступны',
    'network.unconfigured': 'не наладжаны',
    'search.placeholder': 'Хэш, кашалёк, DSR або ZK',
    'search.label': 'Пошук',
    'search.submit': 'Шукаць',
    'nav.dashboard': 'Дашборд',
    'nav.transactions': 'Транзакцыі',
    'nav.wallets': 'Кашалькі',
    'dashboard.title': 'Публічная статыстыка NTP',
    'stats.supply': 'Выпушчана',
    'stats.minted': 'Адчаканена',
    'stats.wallets': 'Кашалькі',
    'stats.transactions': 'Транзакцыі',
    'stats.dsr': 'DSR',
    'stats.zk': 'ZK',
    'chart.title': 'Транзакцыі за 30 дзён',
    'transactions.title': 'Транзакцыі',
    'wallets.title': 'Кашалькі',
    'wallet.title': 'Кашалёк',
    'tx.title': 'Транзакцыя',
    'dsr.title': 'Правілы дэлегаваных выдаткаў (DSR)',
    'zk.title': 'ZK-купоны',
    'filters.title': 'Фільтры',
    'table.hash': 'Хэш',
    'table.sender': 'Адпраўнік',
    'table.receiver': 'Атрымальнік',
    'table.amount': 'Сума',
    'table.date': 'Дата',
    'table.memo': 'Memo',
    'table.wallet': 'Кашалёк',
    'table.balance': 'Баланс',
    'table.sent': 'Зыходныя',
    'table.received': 'Уваходныя',
    'table.status': 'Статус',
    'table.usage': 'Выкарыстанне',
    'table.block': 'Блок',
    'table.zk': 'ZK',
    'table.signature': 'Подпіс',
    'table.latest': 'Апошняе',
    'table.delegate': 'Дэлегат',
    'table.scope': 'Вобласць',
    'table.wallets': 'Кашалькі',
    'table.read': 'Чытанне',
    'table.write': 'Запіс',
    'table.transfer': 'Пераводы',
    'table.txPerHour': 'Транзакцый за гадзіну',
    'table.amountPerHour': 'Сума за гадзіну',
    'table.singleTx': 'Разавая транзакцыя',
    'table.dailyLimit': 'Дзённы ліміт',
    'table.type': 'Тып',
    'table.count': 'Колькасць',
    'table.billingNonce': 'Billing nonce',
    'table.algorithm': 'Алгарытм',
    'table.profile': 'Профіль',
    'table.lastBilling': 'Апошні білінг',
    'table.paymentVerified': 'Плацеж правераны',
    'table.today': 'Сёння',
    'table.next': 'Наступны',
    'table.deadline': 'Дэдлайн',
    'table.created': 'Створаны',
    'table.updated': 'Абноўлены',
    'table.expires': 'Скончыцца',
    'filters.wallet': 'Кашалёк',
    'filters.sender': 'Адпраўнік',
    'filters.receiver': 'Атрымальнік',
    'filters.memo': 'Memo',
    'filters.from': 'Ад',
    'filters.to': 'Да',
    'filters.min': 'Мін.',
    'filters.max': 'Макс.',
    'filters.status': 'Статус',
    'filters.sort': 'Сартаванне',
    'filters.any': 'Любы',
    'filters.publicKey': 'Публічны ключ',
    'detail.keys': 'Публічныя ключы',
    'detail.stats': 'Агрэгаты',
    'detail.transactions': 'Транзакцыі',
    'detail.payments': 'Плацяжы',
    'detail.blocks': 'Блокі',
    'detail.activeBlocks': 'Актыўныя блокі',
    'detail.permissions': 'Дазволы',
    'detail.limits': 'Ліміты',
    'detail.publicData': 'Публічныя даныя',
    'detail.operations': 'Аперацыі',
    'detail.recentUsage': 'Апошнія выкарыстанні',
  },
  en: {
    'dashboard.timezone': 'Time: Belarus, Europe/Minsk / UTC+03',
    'chart.metric': 'Metric',
    'chart.count': 'Transaction count',
    'chart.amount': 'Transaction volume, NTP',
    'chart.period': 'Daily totals in UTC',
    'chart.countTitle': 'Daily transaction count',
    'chart.amountTitle': 'Daily transaction volume, NTP',
    'branding.productVersion': 'Product version:',
    'branding.basedOn': 'based on',
    'common.theme': 'Theme',
    'common.language': 'Language',
    'common.loading': 'Loading',
    'common.error': 'Could not load data',
    'common.empty': 'No data yet',
    'common.apply': 'Apply',
    'common.reset': 'Reset',
    'common.open': 'Open',
    'common.prev': 'Prev',
    'common.next': 'Next',
    'common.yes': 'Yes',
    'common.no': 'No',
    'pagination.total': 'total',
    'pagination.exact': 'exact',
    'pagination.approximate': 'approx.',
    'pagination.page': 'Page',
    'pagination.perPage': 'Per page',
    'pagination.go': 'Go',
    'network.relay': 'Relay',
    'network.storage': 'Storage',
    'network.checking': 'checking',
    'network.online': 'online',
    'network.offline': 'offline',
    'network.unconfigured': 'not set',
    'search.placeholder': 'Hash, wallet, DSR or ZK',
    'search.label': 'Search',
    'search.submit': 'Search',
    'nav.dashboard': 'Dashboard',
    'nav.transactions': 'Transactions',
    'nav.wallets': 'Wallets',
    'dashboard.title': 'Public NTP statistics',
    'stats.supply': 'Supply',
    'stats.minted': 'Minted',
    'stats.wallets': 'Wallets',
    'stats.transactions': 'Transactions',
    'stats.dsr': 'DSR',
    'stats.zk': 'ZK',
    'chart.title': 'Transactions over 30 days',
    'transactions.title': 'Transactions',
    'wallets.title': 'Wallets',
    'wallet.title': 'Wallet',
    'tx.title': 'Transaction',
    'dsr.title': 'Delegated spending rules (DSR)',
    'zk.title': 'ZK coupons',
    'filters.title': 'Filters',
    'table.hash': 'Hash',
    'table.sender': 'Sender',
    'table.receiver': 'Receiver',
    'table.amount': 'Amount',
    'table.date': 'Date',
    'table.memo': 'Memo',
    'table.wallet': 'Wallet',
    'table.balance': 'Balance',
    'table.sent': 'Sent',
    'table.received': 'Received',
    'table.status': 'Status',
    'table.usage': 'Usage',
    'table.block': 'Block',
    'table.zk': 'ZK',
    'table.signature': 'Signature',
    'table.latest': 'Latest',
    'table.delegate': 'Delegate',
    'table.scope': 'Scope',
    'table.wallets': 'Wallets',
    'table.read': 'Read',
    'table.write': 'Write',
    'table.transfer': 'Transfers',
    'table.txPerHour': 'Tx per hour',
    'table.amountPerHour': 'Amount per hour',
    'table.singleTx': 'Single transaction',
    'table.dailyLimit': 'Daily limit',
    'table.type': 'Type',
    'table.count': 'Count',
    'table.billingNonce': 'Billing nonce',
    'table.algorithm': 'Algorithm',
    'table.profile': 'Profile',
    'table.lastBilling': 'Last billing',
    'table.paymentVerified': 'Payment verified',
    'table.today': 'Today',
    'table.next': 'Next',
    'table.deadline': 'Deadline',
    'table.created': 'Created',
    'table.updated': 'Updated',
    'table.expires': 'Expires',
    'filters.wallet': 'Wallet',
    'filters.sender': 'Sender',
    'filters.receiver': 'Receiver',
    'filters.memo': 'Memo',
    'filters.from': 'From',
    'filters.to': 'To',
    'filters.min': 'Min',
    'filters.max': 'Max',
    'filters.status': 'Status',
    'filters.sort': 'Sort',
    'filters.any': 'Any',
    'filters.publicKey': 'Public key',
    'detail.keys': 'Public keys',
    'detail.stats': 'Stats',
    'detail.transactions': 'Transactions',
    'detail.payments': 'Payments',
    'detail.blocks': 'Blocks',
    'detail.activeBlocks': 'Active blocks',
    'detail.permissions': 'Permissions',
    'detail.limits': 'Limits',
    'detail.publicData': 'Public data',
    'detail.operations': 'Operations',
    'detail.recentUsage': 'Recent usage',
  },
};

let currentLanguage = readStoredLanguage();
const listeners = new Set();

export function t(key) {
  return dictionaries[currentLanguage]?.[key] || dictionaries.ru[key] || key;
}

export function getCurrentLanguage() {
  return currentLanguage;
}

export function setLanguage(lang) {
  const next = SUPPORTED_LANGS.includes(lang) ? lang : 'ru';
  currentLanguage = next;
  try {
    localStorage.setItem('ntp_ui_lang', next);
  } catch (_) {}
  if (globalThis.document) {
    document.documentElement.lang = next;
  }
  applyI18n();
  listeners.forEach((listener) => listener(next));
}

export function onLanguageChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function applyI18n(root = globalThis.document) {
  if (!root) return;
  root.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.getAttribute('data-i18n');
    if (key) el.textContent = t(key);
  });
  root.querySelectorAll('[data-i18n-attr]').forEach((el) => {
    const parts = String(el.getAttribute('data-i18n-attr') || '').split(';').map((x) => x.trim()).filter(Boolean);
    parts.forEach((part) => {
      const [attr, key] = part.split(':').map((x) => String(x || '').trim());
      if (attr && key) el.setAttribute(attr, t(key));
    });
  });
}

function readStoredLanguage() {
  try {
    const stored = localStorage.getItem('ntp_ui_lang') || localStorage.getItem('locale') || '';
    if (SUPPORTED_LANGS.includes(stored)) return stored;
  } catch (_) {}
  return 'ru';
}
